import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface Props {
  expense: number;
}

export const TimesheetTotalExpenseCell: FC<Props> = ({ expense }) => {
  return (
    <Stack width="100%" height="100%" justifyContent="center" alignItems="center">
      <Typography fontSize="0.875rem" fontWeight={500}>
        {expense.toFixed(2)}
      </Typography>
    </Stack>
  );
};
